import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

// Thin wrapper around MUI Dialog: fullScreen with a sticky app-bar header and
// a sticky bottom action bar only under sm (so multi-field forms don't fight
// the mobile keyboard inside a tiny centered box). At sm+ this is a normal,
// non-fullScreen Dialog — identical to whatever the page passed in today.
export default function MobileFormDialog({ open, onClose, title, children, actions, maxWidth = 'sm', fullWidth = true, ...rest }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <Dialog open={open} onClose={onClose} fullScreen {...rest}>
        <AppBar position="sticky" elevation={0} sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <Toolbar sx={{ px: 2 }}>
            <Typography variant="h6" sx={{ flex: 1, color: 'white', fontWeight: 700, fontSize: '1.1rem' }} noWrap>
              {title}
            </Typography>
            <IconButton edge="end" onClick={onClose} sx={{ color: 'white' }} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 2, flex: 1 }}>{children}</DialogContent>
        {actions && (
          <Box
            sx={{
              position: 'sticky',
              bottom: 0,
              display: 'flex',
              gap: 1,
              p: 2,
              pb: 'calc(16px + env(safe-area-inset-bottom))',
              bgcolor: 'background.paper',
              borderTop: '1px solid',
              borderColor: 'divider',
            }}
          >
            {actions}
          </Box>
        )}
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} {...rest}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}
